import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { TextBlockCombinationOption } from '..';

@Injectable({ providedIn: 'root' })
export class TextBlockCombinationOptionService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}`;

  loadTextBlockCombinations(): Observable<{
    count: number;
    result: TextBlockCombinationOption[];
  }> {
    return this.http.get<{
      count: number;
      result: TextBlockCombinationOption[];
    }>(`${this.baseUrl}/text-block-combinations`);
  }
}
